import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiHelmet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 9c-.37 0-.72-.2-.9-.55a.993.993 0 0 1 .45-1.34l2-1a.99.99 0 0 1 1.34.45c.25.49.05 1.09-.45 1.34l-2 1c-.14.07-.3.11-.45.11L8 9ZM15.55 8.89c.15.08.3.11.45.11l-.01-.01c.37 0 .72-.2.9-.55.24-.49.04-1.09-.45-1.34l-2-1a1.01 1.01 0 0 0-1.34.45c-.24.49-.04 1.09.45 1.34l2 1Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.99 14H22v-2c0-5.51-4.49-10-10-10S2 6.49 2 12v1.472c-.007.082-.01.165-.01.248v1.56c0 .937.432 1.8 1.14 2.359l.9 3.601c.11.45.51.76.97.76h3v-.01a1 1 0 0 0 .89-.55l.816-1.633A3.013 3.013 0 0 0 11.99 18.6a2.982 2.982 0 0 0 2.299 1.208l.821 1.642c.17.34.51.55.89.55h3v.01c.46 0 .86-.31.97-.76l.908-3.632a2.995 2.995 0 0 0 1.112-2.338V14Zm-3.414 4.584-2.285.762.329.664h1.6l.356-1.426ZM4.457 16.106a.995.995 0 0 1 .097.056c.043.022.089.042.136.058l4.59 1.53c.11.03.21.05.32.05.33 0 .64-.16.83-.44l.53-.8a1.245 1.245 0 0 1 2.08 0l.53.8c.19.28.5.44.83.44.11 0 .22-.02.32-.05l4.59-1.53a1 1 0 0 0 .69-.95v-1.55c0-.43-.28-.81-.69-.95l-.59-.2a11.15 11.15 0 0 0-3.53-.57v-.01H8.82c-1.2 0-2.39.19-3.53.57l-.6.2c-.4.14-.68.52-.68.95v1.56a1 1 0 0 0 .447.836ZM5.78 20l-.352-1.407 2.274.758L7.38 20h-1.6Zm14.14-9.127C19.372 6.995 16.029 4 12 4c-4.022 0-7.361 2.986-7.918 6.856l.558-.186c1.35-.45 2.75-.68 4.17-.68h6.38l-.01.01c1.42 0 2.82.23 4.17.68l.57.194Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSkiHelmet;
